module.exports = __webpack_public_path__ + "img/6dbb6f4.jpg";